import React from 'react'
import EditIconBase from 'components/icons/EditIconBase'
import DeleteIcon from 'components/icons/DeleteIcon'
import { Divider, Modal } from 'antd'
import {
  CityName,
  DefaultDiv,
  HeadFlex,
  DefaultFlex,
  IconDiv,
} from 'modules/Settings/Components/Location/style'
import {
  CommonFlex,
  SubTitleDiv,
} from 'modules/Settings/Components/CompanyInfo/style'

const { confirm } = Modal

const LocationInfo = ({
  id,
  branchName,
  city,
  state,
  country,
  defaultLocation,
  onEditClick,
  onDelete,
}) => {
  return (
    <CommonFlex spaceBetween key={id} width="100%">
      <HeadFlex column>
        <SubTitleDiv>{branchName}</SubTitleDiv>
        <CityName>
          {city}, {state}, {country}
        </CityName>
      </HeadFlex>
      <DefaultFlex centerVertically>
        {!!defaultLocation && <DefaultDiv>Default</DefaultDiv>}
        {!!defaultLocation && <Divider type="vertical" />}

        <IconDiv onClick={() => onEditClick(id)}>
          <EditIconBase />
        </IconDiv>

        <IconDiv
          onClick={() =>
            confirm({
              zIndex: '1001',
              title: `Delete ${branchName}?`,
              okText: 'Confirm',
              okType: 'primary',
              cancelText: 'Cancel',
              onOk: () => {
                onDelete(id)
              },
            })
          }
        >
          <DeleteIcon />
        </IconDiv>
      </DefaultFlex>
    </CommonFlex>
  )
}

export default LocationInfo
